import './App.css';
import AppRouter from './AppRouter';
import NavBar from './components/NavBar'
// import Loader from "./components/Loader"

function App() {

// if (loading) {
//   return <Loader/>
// }

  return (
    <>
      <NavBar />
      <AppRouter />
    </>
  );
}

export default App;
